<template>
  <div v-if="renderReady && !model.$disabled">
    <label v-if="getTitle" class="label">
      <w-next-number v-bind="nextNumber" v-if="nextNumber" />

      <template>{{ getTitle }}</template>&nbsp;
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
      <w-description :model="model" v-bind="description">
        <slot name="description" />
      </w-description>
    </label>
    <slot name="afterLabel" />
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-label',
  components: {WTooltip},
  props: {
    model: {
      type: Object,
      // aby móc używać bez podawania modelu
      default: () => ({
        $schema: {
          title: true
        }
      }),
      required: false
    },
    description: {
      type: Object,
      default: () => ({
        value: '',
        tooltip: false,
        htmlContent: false,
        newLine: true
      }),
      required: false
    },
    nextNumber: {
      type: Object,
      default: null,
      required: false
    },
    css: [Object, String, Array]
  },
  mixins: [modelMixin]
};
</script>

<style scoped>
.smart-form label.label {
  display: inline-block;
}
</style>